module.exports = require("node:tty");